<template>
	<div class="vx-row pb-4">
		<vs-sidebar
			parent="body"
			click-not-close
			position-right
			default-index="1"
			color="primary"
			class="add-new-data-sidebar items-no-padding"
			v-model="isSidebarAddActive"
		>
			<div class="flex items-center justify-between px-6 p-4" style="background: #eee">
				<h4>{{ $t("Add") + " " + $t("Vehicles.Vehicles") }}</h4>
				<feather-icon
					icon="XIcon"
					class="cursor-pointer"
					@click.stop="isSidebarAddActive = false"
				></feather-icon>
			</div>
			<add-resource v-if="isSidebarAddActive" :data="{}" @closeSidebarEmit="closeSidebar()" />
		</vs-sidebar>
		<div class="vx-col w-full vs-con-loading__container" id="optimization-download-content">
			<div class="flex justify-center items-center justify-between mb-4 mt-4">
				<vs-navbar-title>
					<span class="text-primary"
						>{{ $t("Vehicles.VehiclesPointsSelected") + ":" }} {{ resources ? resources.length : 0 }}</span
					>
				</vs-navbar-title>
				<div class="flex items-center">
					<!-- Warning Icon for Discarded Items -->
					<vs-button
						v-if="discardedItemsList.length > 0"
						color="warning"
						type="filled"
						class="mr-2"
						icon-pack="feather"
						:icon="'icon-alert-triangle'"
						:title="$t('Frequency.DiscardedItems.Title')"
						@click="activeDiscardedItemsPrompt = true"
					/>
					<vs-button
						v-if="resources.length > 0"
						class="mr-2"
						type="filled"
						icon-pack="feather"
						:icon="'icon-download'"
						:title="$t('UploadFiles.Download') + ' ' + $t('Vehicles.VehiclesPointsSelected')"
						@click.prevent="activeDownload()"
					></vs-button>
					<vs-button
						v-if="1 === 2"
						class="mr-2"
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-repeat"
						:title="$t('GenerationOfRepetitions')"
						@click.prevent="generateRepeatMounted = true"
					></vs-button>
					<vs-button
						class="mr-2"
						color="primary"
						type="filled"
						icon-pack="feather"
						:title="isExpanded ? $t('CollapseEverything') : $t('ExpandAll')"
						:icon="isExpanded ? 'icon-minimize-2' : 'icon-maximize-2'"
						@click.prevent="toggleAll()"
					></vs-button>
					<vs-dropdown
						vs-trigger-click
						class="ml-auto cursor-pointer"
						:title="$t('Add') + ' ' + $t('Vehicles.Vehicle')"
					>
						<vs-button color="primary" type="filled" icon="icon-plus" icon-pack="feather" />
						<vs-dropdown-menu :style="{width: windowWidth > 620 ? '15%' : '20%'}">
							<h4 class="p-4">{{ $t("Vehicles.Vehicles") }}</h4>
							<vs-dropdown-item>
								<div
									class="flex items-center"
									:title="$t('MODULE_ROLE.Add') + ' ' + $t('Vehicles.Vehicle')"
									@click.prevent="showSidebar()"
								>
									<feather-icon
										icon="PlusSquareIcon"
										class="inline-block mr-2 color-logo"
										svgClasses="w-5 h-5"
									/>
									<span>{{ $t("CompanyModule.Add") }}</span>
								</div>
							</vs-dropdown-item>
							<vs-dropdown-group :vs-label="$t('Select')">
								<vs-dropdown-item>
									<div
										class="flex items-center"
										:title="$t('Vehicles.AssignVehicleToltip')"
										@click.prevent="resourceMounted = true"
									>
										<img
											src="@/assets/images/logo/serviroutes.svg"
											style="width: 21px; height: 21px; margin-right: 1px"
											alt=""
										/>
										<span>{{ "Serviroutes" }}</span>
									</div>
								</vs-dropdown-item>
								<vs-dropdown-item>
									<div
										class="flex items-center"
										:title="$t('ResourceModule.ResourceList')"
										@click.prevent="resourceMountedDatarutas = true"
									>
										<img
											src="@/assets/images/logo/datarutas.svg"
											style="width: 17px; height: 17px; margin-right: 4px"
											alt=""
										/>
										<span>{{ "Datarutas" }}</span>
									</div>
								</vs-dropdown-item>
							</vs-dropdown-group>
							<vs-dropdown-group :vs-label="$t('Upload') + ' ' + $t('UploadFiles.File')">
								<vs-dropdown-item>
									<div class="flex items-center mt-2 mb-2" @click.prevent="uploadFileMounted = true">
										<feather-icon
											icon="FilePlusIcon"
											class="inline-block mr-2 color-logo"
											svgClasses="w-5 h-5"
										/>
										<span>{{ $t("VisitPoints.Add") + " " + $t("Vehicles.Vehicles") }}</span>
									</div>
								</vs-dropdown-item>
								<vs-dropdown-item :disabled="resources.length > 0 ? false : true">
									<div
										class="flex items-center mt-2 mb-2"
										:title="$t('UpdatingVehiclesByFileUpload')"
										:disabled="resources.length > 0 ? false : true"
										@click.prevent="uploadFileUpdateMounted = true"
									>
										<feather-icon
											icon="EditIcon"
											class="inline-block mr-2 color-logo"
											svgClasses="w-5 h-5"
										/>
										<span>{{ $t("Vehicles.UpdateVehicle") }}</span>
									</div>
								</vs-dropdown-item>
							</vs-dropdown-group>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
			</div>
			<div v-if="resources.length > 0" class="vx-col w-full lg:block mt-4 mb-2">
				<div class="flex items-center justify-end">
					<template>
						<vs-dropdown vs-trigger-click class="cursor-pointer">
							<div
								class="p-3 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
							>
								<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
							</div>
							<vs-dropdown-menu>
								<vs-dropdown-item @click="setSearchField('Identification')">
									<span>{{ $t("ResourceModule.Table.Identification") }}</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('GroupSearch')">
									<span>{{ $t("GroupSearch") }}</span>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</template>
					<vs-input
						v-model="searchQueryVehicle"
						icon="icon-search"
						icon-pack="feather"
						class="w-full md:w-1/2"
						:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
					/>
				</div>
			</div>
			<list-selected-item-vehicle
				ref="listSelectedItemVehicle"
				:resourceList="getVehicleList"
				:searchQueryVehicle="searchQueryVehicle"
				@getExpanded="getExpanded"
			/>
		</div>
		<optimization-download
			:activeDownload="isActiveDownload"
			:dataToDownload="resources"
			:fieldsOptimization="'vehicles'"
			:textTitle="$t('Vehicles.Vehicles')"
			@activePopupEmit="activePopup"
		/>
		<vs-popup :fullscreen="true" :title="null" :active.sync="resourceMounted" class="vs-popup--content-custom">
			<div class="is-stuck mt-10" style="background: white">
				<vx-card no-shadow card-border>
					<div class="form-header-inner flex justify-between items-center">
						<vs-input
							class="sm:mr-4 mr-0 sm:w-1/3 w-full sm:order-normal order-3 sm:mt-0 mt-4"
							v-model="searchQuery"
							@input="updateSearchQuery($event)"
							:placeholder="this.$t('ResourceModule.Table.Search')"
						/>
						<vs-button
							:size="iconSize"
							class="ml-2"
							icon-pack="feather"
							icon="icon-check"
							:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
							:disabled="getCheckedVehicles.length <= 0"
							@click.prevent="setAssignedResource()"
							>{{
								windowWidth > 620 ? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection") : null
							}}
						</vs-button>
					</div>
				</vx-card>
			</div>
			<vehicle-list
				v-if="resourceMounted"
				ref="VehicleListPopup"
				style="margin-top: 70px"
				:componentParent="'OPTIMIZATION'"
				:customConfig="vehicleListConfig"
			/>
		</vs-popup>
		<!-- RESOURCE LIST COMPONENT DATARUTAS-->
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('ResourceModule.ResourceList') + ' Datarutas'"
			:active.sync="resourceMountedDatarutas"
			@closePopupEmit="closePopupResourceAddEmit"
		>
			<resource-list-datarutas
				v-if="resourceMountedDatarutas && isDatarutasEnabled"
				ref="ResourceDatarutas"
				class="mt-10"
				:customConfig="vehicleListConfigDatarutas"
				:componentParent="'RESOURCE_LIST'"
			>
				<div class="is-stuck--datarutas" style="background: white">
					<vx-card ref="filterCard" class="user-list-filters" no-shadow card-border>
						<template slot="actions">
							<div class="form-header-inner">
								<div class="flex items-center">
									<vs-button
										class="ml-2 mb-4"
										icon-pack="feather"
										icon="icon-check"
										:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
										:size="iconSize"
										:disabled="getCheckedResourceDatarutas.length <= 0"
										@click.prevent="setAssignedResource()"
										>{{
											windowWidth > 620
												? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection")
												: null
										}}
									</vs-button>
								</div>
							</div>
						</template>
					</vx-card>
				</div>
				<vs-divider class="d-theme-border-grey-light" />
			</resource-list-datarutas>
			<not-authorized
				v-else
				:subTitle="$t('NotAuthorizedPage.SubtitleResourceDatarutas')"
				:login="loginDatarutas"
			></not-authorized>
		</vs-popup>
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('UploadFiles.UploadFiles') + '(' + $t('Add') + ' ' + $t('Vehicles.Vehicles') + ')'"
			:active.sync="uploadFileMounted"
		>
			<upload-file
				ref="uploadVehicleAdd"
				:typeService="'VEHICLE'"
				:inputFileId="'inputFileVehicleAdd'"
				:inputFileIcon="'TruckIcon'"
				:typeUploadFile="'VEHICLE_UPLOAD'"
				:typeAction="'ADD'"
				:activateListUploadFile="true"
				:showUploadFileOptimization="showUploadFileOptimization"
				:showSetEquivalenceOptimization="showSetEquivalenceOptimization"
				@setUploadFileOptimization="setUploadFileOptimization"
				@setEquivalenceOptimization="setEquivalenceOptimization"
				@closePopupEmit="closePopupUploadFileAdd"
			/>
		</vs-popup>
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('UploadFiles.UploadFiles') + '(' + $t('Crud.Update') + ' ' + $t('Vehicles.Vehicles') + ')'"
			:active.sync="uploadFileUpdateMounted"
		>
			<upload-file
				ref="uploadVehicleListUpdate"
				:typeService="'VEHICLE'"
				:inputFileId="'inputFileVehicleUpdate'"
				:inputFileIcon="'TruckIcon'"
				:typeUploadFile="'VEHICLE_UPLOAD'"
				:typeAction="'UPDATE'"
				:activateListUploadFile="false"
				:showUploadFileOptimization="showUploadFileOptimization"
				:showSetEquivalenceOptimization="showSetEquivalenceOptimization"
				@setUploadFileOptimization="setUploadFileOptimization"
				@setEquivalenceOptimization="setEquivalenceOptimization"
				@closePopupEmit="closePopup"
			/>
		</vs-popup>
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('GenerationOfRepetitions')"
			:active.sync="generateRepeatMounted"
		>
			<generate-repeat
				v-if="generateRepeatMounted"
				:showPopup="generateRepeatMounted"
				:activeTabRepeat="2"
				:toggleAllSelectedInformation="toggleAll"
				@closePopupEmit="closePopupGenerateRepeatEmit()"
			/>
		</vs-popup>
		<vs-prompt
			class="prompt-content"
			:title="$t('Frequency.DiscardedItems.Title')"
			:active.sync="activeDiscardedItemsPrompt"
			:cancelText="$t('Routing.Title.Close')"
			:buttons-hidden="true"
			@cancel="closeDiscardedItemsPrompt"
			@close="closeDiscardedItemsPrompt"
		>
			<div class="text-left">
				<p>{{ $t("Frequency.DiscardedItems.Message") }}</p>
				<ul class="mt-2 mb-10 pl-4">
					<li v-for="(item, index) in paginatedDiscardedItems" :key="index" class="mb-2">❌ {{ item }}</li>
				</ul>
				<!-- Pagination -->
				<div v-if="showDiscardedItemsPagination" class="mt-2 mb-10 text-center">
					<vs-pagination
						:total="totalDiscardedItemsPages"
						:max="5"
						v-model="currentDiscardedItemsPage"
						@change="changeDiscardedItemsPage"
					/>
				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import {listSelectVehicleMixin} from "@/components/optimization/resource/model/ListSelectVehicleMixin";

export default {
	mixins: [listSelectVehicleMixin],
};
</script>
<style lang="scss" scoped>
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 90vw;
		height: 100vh;
		display: flex;
		flex-direction: column;
		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
.scroll-area--form {
	margin: auto;
	width: 100%;
	min-height: 300px;
	max-height: calc(100vh - 200px);
	overflow-y: auto;
}
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 200px;
	max-height: calc(100vh - 300px);
	overflow-y: auto;
}
.is-stuck {
	position: fixed;
	top: 12px;
	inset-inline-start: 0;
	margin-inline-start: 16px;
	width: calc(100% - 38px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.is-stuck--datarutas {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 60px);
	z-index: 14;
}
.color-logo {
	color: rgba(35, 39, 133, 1);
}

/* Responsive adjustments */
@media (max-height: 600px) {
	.scroll-area--form {
		max-height: calc(100vh - 150px);
		min-height: 200px;
	}
	.scroll-area {
		max-height: calc(100vh - 200px);
		min-height: 150px;
	}
}

@media (max-width: 768px) {
	.scroll-area--form {
		max-height: calc(100vh - 180px);
	}
	.scroll-area {
		max-height: calc(100vh - 250px);
	}
}
</style>
<style lang="scss">
#VehicleItemDelivery {
	.vs-collapse-item--header {
		color: rgba(var(--vs-dark), 1);
		font-weight: bold;
		font-size: 17px;
	}
}
</style>
